import { BudgetBys } from 'business/constants';
import {
    BudgetVentilatedDataWithCadrageT,
    BudgetVentilatedDataT,
} from 'routes/BudgetModule/config/types';

export const addSpacesToResourceDoublons = (
    data: BudgetVentilatedDataWithCadrageT[] | BudgetVentilatedDataT[],
    by: BudgetBys,
): BudgetVentilatedDataWithCadrageT[] | BudgetVentilatedDataT[] => {
    const doublonNameCounts: Record<string, number> = {};
    const resourceNameField: string = String(by);
    return data.map((responseData) => {
        const resourceName = String(
            responseData[resourceNameField as keyof BudgetVentilatedDataT],
        );
        // if resourceName is already known -> increment, else -> initialize count to 1
        doublonNameCounts[resourceName] =
            doublonNameCounts[resourceName] + 1 || 0;
        // we had spaces at the end of resource names doublons
        return {
            ...responseData,
            [resourceNameField]:
                resourceName + ' '.repeat(doublonNameCounts[resourceName]),
        };
    });
};
